import React from 'react';
import SkeletonCard from '../../../components/Skeleton/Card';

const Loading: React.FC = () => <SkeletonCard height={300} />;

export default Loading;
